import {useState, useEffect, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {message, Modal} from 'antd';
import {
  getAllCategories,
  selectCategories,
  deleteCategoryMonitor,
  activeCategory
} from '../../redux/slices/categoriesPuntoVenta';
import PuntoVentaCategoriesUI from './components/CategoriesUI';
import {
  listPuntoVenta
} from '../../redux/slices/puntosVenta';

const PuntoVentaCategories = () => {
  const [loading, handleLoading] = useState(true);
  const [editorVisible, handleEditorVisible] = useState(false);
  const [category, handleCategory] = useState(null);
  const types = useSelector(selectCategories);
  const puntosVenta = useSelector(listPuntoVenta);
  const dispatch = useDispatch();

  const getCategories = useCallback(async() => {
    handleLoading(true);
    const [response] = await Promise.all([
      dispatch(getAllCategories()),
    ]);

    console.log("types",types)
    if (response.status !== 'success') {
      message.error('¡Hubo un problema!');
    }
    handleLoading(false);
  }, [dispatch]);

  const initialFetch = useCallback(async () => {
    handleLoading(true);
    await getCategories();
    handleLoading(false);
  }, [dispatch, getCategories]);


  useEffect(() => {
    initialFetch();
  }, [initialFetch]);


  const openEditor = categoryToEdit => {
    handleCategory(categoryToEdit);
    handleEditorVisible(true);
  };

  const newCategory = () => {
    handleCategory(null);
    handleEditorVisible(true);
  };

  const closeEditor = () => {
    handleCategory(null);
    handleEditorVisible(false);
  };

  const confirmDelete = idCategory => {
    console.log("puntosVenta", puntosVenta);
  
    const hasMultipleOccurrences = puntosVenta.puntosVenta.some(type => type.typeId === idCategory);
  
    // Mensaje adicional si hay múltiples coincidencias
    const extraWarning = hasMultipleOccurrences
      ? "Al eliminar esta categoría, los puntos de venta asociados a ella ya no aparecerán en la web hasta que los asocies a otra categoría."
      : "";
  
    Modal.confirm({
      title: '¿Estás seguro de eliminar esta categoría?',
      content: (
        <>
          <p>Esta información no se podrá recuperar.</p>
          {extraWarning && <p style={{ color: 'red' }}>{extraWarning}</p>}
        </>
      ),
      okText: 'Eliminar',
      okType: 'danger',
      cancelText: 'Cancelar',
      async onOk() {
        await removeCategory(idCategory);
      },
      onCancel() {},
    });
  };
  

  const removeCategory = async idCategory => {
    const response = await dispatch(deleteCategoryMonitor(idCategory));
    if (response.status !== 'success') {
      message.error('¡Hubo un problema!');
    } else {
      message.success('Categoría eliminada correctamente');
    }
  };

  const handleActive = async (idCategory, val) => {
    console.log("entro??")
    const response = await dispatch(activeCategory(idCategory, val));
    if (response.status !== 'success') {
      message.error('¡Hubo un problema!');
    }
  };

  const selectBranch = e => {
    //handleBranch(e);
    getCategories(e);
  };

  return (
    <PuntoVentaCategoriesUI
      loading={loading}
      category={category}
      openEditor={openEditor}
      editorVisible={editorVisible}
      closeEditor={closeEditor}
      newCategory={newCategory}
      confirmDelete={confirmDelete}
      handleCategory={handleCategory}
      handleActive={handleActive}
      types={types}
    />
  );
}

export default PuntoVentaCategories;
